// Cart Recommendations Handler
// Fetches and displays product recommendations in cart drawer

(function() {
  'use strict';

  class CartRecommendations {
    constructor() {
      this.refresh();
      
      if (!this.target) return;
      
      console.log('🎯 Cart Recommendations initialized');
    }

    // The recommendations block lives inside .cart-items-container, which is
    // replaced wholesale on every cart update, so re-query before acting.
    refresh() {
      this.target = document.querySelector('.cart-recommendations');
      this.wrapper = document.querySelector('#cart-recommendations');
      this.recCollSlider = document.querySelector('[data-rec-coll-slider]');
    }

    async update(cartData) {
      this.refresh();
      if (!this.target) return;
      
      console.log('📦 Updating recommendations, cart items:', cartData?.items?.length);

      // If collection-based recommendations exist, they're already updated by Liquid
      if (this.recCollSlider) {
        console.log('✅ Collection recommendations (already updated by Liquid)');
        return;
      }

      // Dynamic recommendations (from Shopify API)
      // Only hide if cart is explicitly empty, not on missing data
      if (cartData?.items && cartData.items.length === 0) {
        this.target.style.display = 'none';
        return;
      }

      // If we have cart data with items, update
      if (cartData?.items?.length > 0) {
        await this.updateDynamicRecommendations(cartData);
      }
    }

    async updateDynamicRecommendations(cartData) {
      try {
        const productIds = cartData.items.map(item => item.product_id);
        
        // Fetch recommendations for each cart item
        const promises = productIds.map(id =>
          fetch(`${window.routes.recommendations}?product_id=${id}&limit=3&intent=related&section_id=cart-recommendations`)
            .then(res => res.ok ? res.text() : null)
            .catch(() => null)
        );
        
        const results = await Promise.all(promises);
        
        // Parse HTML responses and extract product cards
        const allProducts = [];
        const seenIds = new Set(productIds); // Exclude cart items
        
        for (const html of results) {
          if (!html) continue;
          
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const cards = parsed.querySelectorAll('.product-card-wrapper[data-product-id]');
          
          cards.forEach(card => {
            const productId = parseInt(card.dataset.productId);
            if (!seenIds.has(productId)) {
              seenIds.add(productId);
              allProducts.push(card.outerHTML);
            }
          });
        }
        
        // Update wrapper
        if (this.wrapper && allProducts.length > 0) {
          this.wrapper.innerHTML = allProducts.join('');
          this.target.style.display = 'block';
          
          const sliderComponent = this.wrapper.closest('slider-component');
          this.updateSliderVisibility(sliderComponent);
          
          console.log(`✅ Dynamic recommendations: ${allProducts.length} products`);
        } else {
          this.target.style.display = 'none';
          console.log('ℹ️ No recommendations available');
        }
      } catch (error) {
        console.error('❌ Dynamic recommendations error:', error);
        this.target.style.display = 'none';
      }
    }

    updateSliderVisibility(sliderComponent) {
      if (!sliderComponent) {
        // If no slider component, show the block (might have static content)
        if (this.target) {
          this.target.style.display = 'block';
        }
        return;
      }
      
      const slides = sliderComponent.querySelectorAll('.new-slider-item');
      const block = sliderComponent.closest('.cart-recommendations');
      
      if (block) {
        // Only hide if definitely no slides
        if (slides.length === 0) {
          block.style.display = 'none';
        } else {
          block.style.display = 'block';
        }
      }
    }
  }

  // Create singleton instance
  const recommendationsHandler = new CartRecommendations();

  // Export to global scope
  window.updateCartRecommendations = function(cartData) {
    recommendationsHandler.update(cartData);
  };

  // Initialize on page load
  document.addEventListener('DOMContentLoaded', function() {
    const cartJsonElement = document.querySelector('[data-cart-json-data]');
    if (cartJsonElement) {
      try {
        const cartData = JSON.parse(cartJsonElement.textContent);
        if (cartData?.items?.length) {
          recommendationsHandler.update(cartData);
        }
      } catch (error) {
        console.error('❌ Recommendations init error:', error);
      }
    }
  });

})();
